import { z } from "zod";
import {
  ACTUAL_DURATION,
  ACTUAL_END_DATE,
  ACTUAL_START_DATE,
  PERCENTAGE,
  TASK_STATUS,
} from "./consts";

export const schema = z.object({
  [ACTUAL_START_DATE]: z.string().optional(),
  [ACTUAL_END_DATE]: z.string().optional(),
  [PERCENTAGE]: z.string().optional(),
  [TASK_STATUS]: z.string().optional(),
  [ACTUAL_DURATION]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
